/**
 * 공용 블록 타입 정의 — FloatingMenu·서식 팝업 툴바의 블록 유형 select 공유.
 * ui 모듈끼리 직접 import 하지 않도록 여기로 추출(순환의존 차단).
 * [option value, locale key, fallback label]
 *   value: "paragraph" | "heading:N" | "heading:N:toggle" | "toggleListItem" | ...
 */
export const BLOCK_TYPE_DEFS = [
  ["paragraph", "paragraph", "본문"], ["heading:1", "heading1", "제목1"], ["heading:2", "heading2", "제목2"], ["heading:3", "heading3", "제목3"],
  ["heading:4", "heading4", "제목4"], ["heading:5", "heading5", "제목5"], ["heading:6", "heading6", "제목6"],
  ["heading:1:toggle", "toggleHeading1", "토글 제목 1"], ["heading:2:toggle", "toggleHeading2", "토글 제목 2"], ["heading:3:toggle", "toggleHeading3", "토글 제목 3"],
  ["bulletListItem", "bulletListItem", "• 목록"], ["numberedListItem", "numberedListItem", "1. 목록"], ["checkListItem", "checkListItem", "☑ 체크"], ["toggleListItem", "toggleList", "토글 목록"],
  ["quote", "quote", "인용"], ["codeBlock", "codeBlock", "코드"],
];
